const TYPES = {
  POINTS: 'points',
  STAMP: 'stamp',
  MULTI_STAMP: 'multi_stamp',
  CASHBACK: 'cashback',
  GIFT_CARD: 'gift_card',
  COUPON: 'coupon',
  DISCOUNT: 'discount',
  TIERED: 'tiered',
  POINTS_TIERED: 'points_tiered',
  POINT: 'point_card',
}

const TYPE_LABELS = {
  points: 'Points Card',
  point_card: 'Point Card',
  stamp: 'Stamp Card',
  multi_stamp: 'Multi-Stamp Card',
  cashback: 'Cashback Card',
  gift_card: 'Gift Card',
  coupon: 'Coupon',
  discount: 'Discount',
  tiered: 'Tiered Loyalty',
  points_tiered: 'Points + Tiers',
}

const DISCOUNT_TYPE = {
  PERCENT: 'percent',
  VALUE: 'value',
}

const DISCOUNT_TYPE_LABELS = {
  [DISCOUNT_TYPE.PERCENT]: 'Percent',
  [DISCOUNT_TYPE.VALUE]: 'Value',
}

const REWARD_TYPE = {
  DISCOUNT: 'discount',
  CAMPAIGN: 'campaign',
}
const EXPIRE_TYPE = {
  NEVER: 'never',
  IN_DAYS: 'in_days',
  ON_DATE: 'on_date',
}

const REDEMPTION_TYPE = {
  ANY_DAY: 'any_day',
  CUSTOM: 'custom',
}

const CAMPAIGN_QUANTITY_TYPE = {
  UNLIMITED: 'unlimited',
  LIMITED: 'limited',
}

const REDEMPTION_USAGE_TYPE = {
  SINGLE: 'single',
  MULTI: 'multi',
  UNLIMITED: 'unlimited',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
}

// Human labels for the enums that are rendered straight into <select> options. Without
// these the merchant sees the raw enum key — "UNLIMITED", "IN_DAYS" — and, worse, a key
// cannot be translated, which is why the Arabic UI showed English dropdown values
// throughout campaign creation. These strings are translation keys: pass them through t().
const REWARD_TYPE_LABELS = {
  discount: 'Discount',
  campaign: 'Campaign',
}

const CAMPAIGN_QUANTITY_TYPE_LABELS = {
  unlimited: 'Unlimited',
  limited: 'Limited',
}

const EXPIRE_TYPE_LABELS = {
  never: 'Never',
  in_days: 'In Days',
  on_date: 'On Date',
}

const REDEMPTION_TYPE_LABELS = {
  any_day: 'Any Day',
  custom: 'Custom',
}

const REDEMPTION_USAGE_TYPE_LABELS = {
  single: 'Single',
  multi: 'Multiple',
  unlimited: 'Unlimited',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
}

export {
  TYPES,
  TYPE_LABELS,
  CAMPAIGN_QUANTITY_TYPE_LABELS,
  EXPIRE_TYPE_LABELS,
  REWARD_TYPE_LABELS,
  REDEMPTION_TYPE_LABELS,
  REDEMPTION_USAGE_TYPE_LABELS,
  DISCOUNT_TYPE,
  DISCOUNT_TYPE_LABELS,
  EXPIRE_TYPE,
  REDEMPTION_TYPE,
  CAMPAIGN_QUANTITY_TYPE,
  REDEMPTION_USAGE_TYPE,
  REWARD_TYPE,
}
